import Image from "next/image";
import ArrowRightIcon from "~/public/static/icons/arrow-right.svg";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showAppModal } from "~/redux/actions/app";
import settings from "~/settings";
import { setNavigationStorage } from "~/utils/ui";

const UserResume = (props) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (props.token) {
      window.open(`${settings.talentUrl}/me/profile`, "_blank");
      setNavigationStorage("talentResume");
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };

  return (
    <div
      className="user-resume-link"
      onClick={handleClick}
    >
      <span className="user-resume-link-text">我的简历</span>
      <Image
        src={ArrowRightIcon}
        width={4}
        height={12}
        className="user-resume-link-icon"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserResume);
